import { render, staticRenderFns } from "./IdentityManage.vue?vue&type=template&id=1d96e4df&scoped=true&"
import script from "./IdentityManage.vue?vue&type=script&lang=js&"
export * from "./IdentityManage.vue?vue&type=script&lang=js&"
import style0 from "./IdentityManage.vue?vue&type=style&index=0&id=1d96e4df&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d96e4df",
  null
  
)

export default component.exports